/**
 * PDP gallery: hover thumbnails switch the hero image (desktop + hover only).
 * Bottom fade via .rl-thumb-col::after (anchored outside overflow).
 * Mobile / touch: unchanged (swipe, no hover listeners).
 */
(function () {
  const HOVER_MQ = '(hover: hover) and (min-width: 750px)';
  const DESKTOP_MQ = '(min-width: 750px)';

  function bindHover(gallery) {
    if (!window.matchMedia(HOVER_MQ).matches) return;
    if (gallery.dataset.rlHoverBound === 'true') return;

    const thumbs = gallery.querySelector('[id^="GalleryThumbnails"]');
    if (!thumbs) return;

    thumbs.querySelectorAll('[data-target]').forEach((item) => {
      const button = item.querySelector('button');
      if (!button) return;
      button.addEventListener('mouseenter', () => {
        if (!window.matchMedia(HOVER_MQ).matches) return;
        if (typeof gallery.setActiveMedia === 'function') {
          gallery.setActiveMedia(item.dataset.target, false);
        }
      });
    });

    gallery.dataset.rlHoverBound = 'true';
  }

  function ensureThumbCol(thumbs) {
    if (thumbs.parentElement && thumbs.parentElement.classList.contains('rl-thumb-col')) {
      return thumbs.parentElement;
    }
    const wrap = document.createElement('div');
    wrap.className = 'rl-thumb-col';
    thumbs.parentNode.insertBefore(wrap, thumbs);
    wrap.appendChild(thumbs);
    return wrap;
  }

  function updateScrollFade(thumbs, wrap) {
    if (!thumbs || !wrap || !window.matchMedia(DESKTOP_MQ).matches) {
      if (wrap) wrap.classList.remove('is-scrollable-bottom');
      return;
    }
    const canScroll = thumbs.scrollHeight > thumbs.clientHeight + 2;
    const remaining = thumbs.scrollHeight - thumbs.scrollTop - thumbs.clientHeight;
    wrap.classList.toggle('is-scrollable-bottom', canScroll && remaining > 2);
  }

  function bindScrollFade(gallery) {
    const thumbs = gallery.querySelector('[id^="GalleryThumbnails"]');
    if (!thumbs || thumbs.dataset.rlScrollFadeBound === 'true') return;

    const wrap = ensureThumbCol(thumbs);
    const refresh = () => updateScrollFade(thumbs, wrap);

    thumbs.addEventListener('scroll', refresh, { passive: true });
    window.addEventListener('resize', refresh);
    window.addEventListener('load', refresh);
    thumbs.querySelectorAll('img').forEach((img) => {
      if (!img.complete) img.addEventListener('load', refresh, { once: true });
    });
    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(refresh).observe(wrap);
      new ResizeObserver(refresh).observe(thumbs);
      const list = thumbs.querySelector('.thumbnail-list');
      if (list) new ResizeObserver(refresh).observe(list);
    }
    requestAnimationFrame(refresh);
    setTimeout(refresh, 150);
    setTimeout(refresh, 600);
    thumbs.dataset.rlScrollFadeBound = 'true';
  }

  function init() {
    document.querySelectorAll('media-gallery').forEach((gallery) => {
      bindHover(gallery);
      bindScrollFade(gallery);
    });
  }

  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('media-gallery').then(init);
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
